<script>
    export let content;

    import { Link } from 'svelte-navigator'
    import { getURL } from '../../utils/functions'

    const title = content.title;
    const text = content.text;
    const anchor = content.anchor;
    const thankYou = content.thankyou;

    let inputEmail = '';
    let inputEmailElement;
    let inputGDPRElement;

    let status = '';

    const subscribeNewsletter = async () => {

        if (validateForm()) {
            const data = {
                email: inputEmail
            }

            try {
                fetch(getURL('/newsletters'), {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    referrerPolicy: 'no-referrer',
                    body: JSON.stringify(data)
                })
                .then(() => {
                    status = 'success';
                    clearForm();
                })
                .catch(error => status = 'fail')
            } catch (error) {
                status = 'fail'
            }

        } else {
            status = 'validate';
        }
    };

    const clearForm = () => {
        inputEmail = '';
        inputGDPRElement.value = "false";
    };

    const validateForm = () => {
        return inputEmailElement.checkValidity() && inputGDPRElement.checkValidity();
    }
</script>

<!-- Begin of register / socials section -->
<div class="section section-register section-cent fp-auto-height-responsive bg-primary" data-section={anchor}>
    
    <section class="content clearfix">

        <div class="content-centered c-columns fit">
            
            <div class="wrapper anim">
                <!-- title and description -->
                <div class="title-desc">
                    <span class="anim-wrapper">
                        <h2 class="page-title">{title}</h2>
                    </span>
                    
                    <span class="anim-wrapper">
                        <p class="text-center">{text}</p>    
                    </span>
                </div>
                <!-- subscription form -->
                <div class="subscription">
                    <form id="subscription-form" class="form send_email_form zoom-out">
                        {#if status === 'success'}
                            <p class="feedback form-success-visible text-center">{thankYou}</p>
                        {:else if status === 'fail'}
                            <p class="feedback form-success-visible text-center">Network error.</p>
                        {:else if status === 'validate'}
                            <p class="feedback form-success-visible text-center">Please enter a valid email address.</p>
                        {/if}
                        <div>
                            <input id="reg-email" class="input form-success-invisible" name="email" type="email" required placeholder="your@email.address" data-validation-type="email" on:keydown={() => status = ''} bind:value={inputEmail} bind:this={inputEmailElement}>
                            <button type='button' id="submit-email" class="btn circ-btn form-success-invisible" name="submit_email" on:click={subscribeNewsletter}>
                                <span class="ion-checkmark"></span>
                            </button>
                        </div>
                        
                        <div class="gdpr">
                            <input id="gdpr-email" type="checkbox" required bind:this={inputGDPRElement}>
                            <label for="gdpr-email">By signing up for our newsletter, you agree to our <a href="/privacy-policy" target="_blank">Terms and privacy policy</a>.</label>
                        </div>
                        
                    </form>
                </div>
            </div>
        </div>

    </section>
</div>
<!-- End of register / socials section -->